<template>
  
      <ion-toolbar class="header_app header_app_studio">
        <ion-buttons slot="start">
          <ion-menu-button class="conf_toolbar" menu="menustudio" @click="blurActiveElement()">
            <ion-img src="assets/ICONOS/dex_tabs.png" ></ion-img>
          </ion-menu-button>
        </ion-buttons>
        <ion-buttons class="logo_toolbar logo_toolbar_studio" slot="end" style="">
          <ion-img src="assets/ICONOS/Servicios/vybroo-studio.svg"></ion-img>
        </ion-buttons>
        <ion-menu-button class="dex_tabs" slot="end" menu="menudex" @click="blurActiveElement()">
            <ion-icon class="i_conf" src="assets/ICONOS/configuracion.svg" ></ion-icon>
            <ion-icon class="i_plus" src="assets/ICONOS/plus.svg" ></ion-icon>
        </ion-menu-button>
        <ion-title>{{ $route.params.id }}</ion-title>
      </ion-toolbar>
      
</template>

<script>
import {
  IonToolbar,
  IonButtons,
  IonMenuButton,
  IonTitle,
  IonImg,
  IonIcon,
} from '@ionic/vue';

export default {
    name:"headertoolbarstudio",
    components: {
      IonToolbar,
      IonButtons,
      IonMenuButton,
      IonTitle,
      IonImg,
      IonIcon,
    },
    methods: {
      blurActiveElement() {
        try {
          const active = document && document.activeElement;
          if (active && typeof active.blur === 'function') active.blur();
        } catch (error) {
          console.log('No se pudo limpiar foco activo:', error);
        }
      },
    },
}
</script>
